import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Typography from "../../components/Typography/Typography";
import LibrarySearchBar from "../../components/LibrarySearchBar/LibrarySearchBar";
import LatestSearchBox from "./LatestSearchBox";
import { Semantic } from "../../Icons/Semantic";
import Button from "../../components/Button/Button";

export default function ResearchStarterView({
  searchData,
  searchValue,
  setSearchValue,
  handleSearch,
}) {
  const isMobile = window.innerWidth < 768;

  return (
    <div className="overflow-y-hidden scrollbar-hidden px-6 md:mx-auto md:w-[40rem] w-auto h-full flex flex-col items-center justify-top md:justify-center pt-10 md:pt-0 gap-9">
      <div className="w-full flex flex-col items-center gap-7">
        <Typography
          size="28"
          desktopSize="48"
          family="serif"
          weight="sb"
          align="center"
        >
          Trova le fonti giuste.
          <br />
          Inizia ora!
        </Typography>
        <LibrarySearchBar
          fullWidth
          value={searchValue}
          onChange={setSearchValue}
          onSearch={handleSearch}
        />
      </div>

      <div className="w-full flex flex-col gap-2">
        {/* Only render if we have recent searches */}
        {searchData && searchData.history && searchData.history.length > 0 ? (
          <>
            {searchData.history
              .sort(
                (a, b) => new Date(b.creation_date) - new Date(a.creation_date)
              )
              .slice(0, isMobile ? 2 : 4)
              .reduce((acc, item, index) => {
                if (index % 2 === 0) acc.push([item]);
                else acc[acc.length - 1].push(item);
                return acc;
              }, [])
              .map((pair, idx) => (
                <div key={idx} className="flex flex-col md:flex-row gap-2">
                  {pair.map((item) => (
                    <LatestSearchBox
                      key={item.chat_id}
                      title={item.title}
                      id={item.chat_id}
                      time={item.creation_date}
                    />
                  ))}
                </div>
              ))}
            <Link to="/client/research/chats">
              <div className="w-full flex gap-2 justify-center py-3 px-6 bg-white text-black border-2 border-gray-100 hover:border-gray-200 active:border-black rounded-[8px] cursor-pointer">
                <Typography size="12" weight="sb" align="center">
                  Visualizza tutte le chat
                </Typography>
                <ArrowRight size={16} />
              </div>
            </Link>
          </>
        ) : null}
      </div>

      <div className="flex w-full justify-center">
        <Button text="Powered by Semantic Scholar" size="sm" licon={<Semantic size={20} />} type="bw" width="fit" onClick={() => window.open('https://www.semanticscholar.org/', '_blank', 'noopener,noreferrer')}
        />
      </div>
    </div>
  );
}